import { PaymentSubmitProps } from '@msc-b2c/interfaces/types';
import { GuestCheckbox } from '../../../guestcheckbox/GuestCheckbox';
import styles from '../../paymentbox.module.scss';
import { sanitize } from '@msc-b2c/shared-utils';

const PaymentSubmit = ({
  id,
  terms,
  onCheck,
  checked,
  children,
  cardAuthorization,
  cardAuthorizationLabel,
  cardAuthorizationDescription,
  cardAuthorizationAriaLabel,
  isCardAuthChecked,
  onCardAuthChange,
}: PaymentSubmitProps) => {
  const termsHtml = terms ? terms.replace(/<a /g, '<a target="_blank" ') : '';
  const sanitizedTermsHtml = termsHtml
    ? sanitize(termsHtml, {
        ADD_ATTR: ['target', 'class'],
      })
    : '';

  const termsLabelId = `${id}-terms-label`;

  return (
    <div className={styles.submitContainer}>
      {cardAuthorization && (
        <div className={styles.cardAuthorization}>
          <div className={styles.cardAuthorizationCheckbox}>
            <GuestCheckbox
              id="card-authorization"
              ariaLabel={cardAuthorizationAriaLabel || cardAuthorizationLabel}
              onChange={onCardAuthChange}
              checked={isCardAuthChecked}
            />
            <span className={styles.cardAuthorizationLabel}>
              {cardAuthorizationLabel}
              {cardAuthorizationDescription && (
                <span className={styles.cardAuthorizationDescription}>
                  {cardAuthorizationDescription}
                </span>
              )}
            </span>
          </div>
        </div>
      )}
      <div className={styles.terms}>
        <GuestCheckbox
          id={id}
          ariaLabelledBy={termsLabelId}
          onChange={onCheck}
          checked={checked}
        />
        <span
          id={termsLabelId}
          dangerouslySetInnerHTML={{ __html: sanitizedTermsHtml }}
        ></span>
      </div>
      {children}
    </div>
  );
};

export default PaymentSubmit;
